var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,2h-4V0h-2V2H8V0h-2V2H2l-1,1V22l1,1H22l1-1V3l-1-1Zm-1,19H3V10H21v11Zm0-13H3V4h3v2h2v-2h8v2h2v-2h3v4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/1762842647/media/icon-calendar.06f34dafdf4cfd64b2cf0c5101981e3e.svg";
export { ForwardRef as ReactComponent };